export default function shouldHaveYoutube(influencer) {
  return (
    influencer &&
    influencer.youtube_streamer &&
    influencer.youtube_streamer.channel_id
  );
}
